module.exports = __webpack_public_path__ + "static/dinosaur2-ff830aa33f04effd58510ce74608bc99.png";